import Icon from '@/components/ui/AppIcon';

interface TrustSignal {
  id: string;
  icon: string;
  title: string;
  description: string;
}

interface TrustSignalsProps {
  signals: TrustSignal[];
}

const TrustSignals = ({ signals }: TrustSignalsProps) => {
  return (
    <section className="py-12 px-6 bg-background border-y border-border">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {signals.map((signal) => (
            <div key={signal.id} className="flex items-start gap-4">
              <div className="flex items-center justify-center w-12 h-12 bg-primary/10 text-primary rounded-lg flex-shrink-0">
                <Icon name={signal.icon as any} size={24} />
              </div>
              <div>
                <h3 className="font-heading text-lg font-bold text-foreground mb-1">
                  {signal.title}
                </h3>
                <p className="text-muted-foreground text-sm">
                  {signal.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSignals;